import { useDataRequest } from "../../common/hooks/api";
import { OrganizationUser } from "../../common/models";
import { NetworkRequestState } from "../../common/models/NetworkRequest";
import { Api } from "../../common/service/Api";
import { OrganizationPublicId } from "../../common/service/server/Types";
import { Error as RequestsError } from "../copy/requests";

export const useOrganizationUsers = (
  organizationId: OrganizationPublicId,
  extendedOrgs: Boolean = false,
): [OrganizationUser[], NetworkRequestState, () => void] => {
  const { refresh, request, result } = useDataRequest({
    queryKey: ["organizationUsers", organizationId, extendedOrgs],
    api: () => Api.organizationUser.getUsers(organizationId, extendedOrgs),
    messages: {
      defaultError: RequestsError.GetOrgUsers,
    },
    notReady: !organizationId,
  });

  // The query cache is persisted to localStorage, so a malformed response body
  // (e.g. a non-JSON 2xx that axios resolves as a string) would otherwise be
  // restored on every boot and crash callers that expect an array.
  const users = Array.isArray(result) ? result : undefined;

  return [users, request, refresh];
};
